import initSpanglesColorGuide from "components/jiffy/spangles-color-guide/spangles-color-guide";

document.addEventListener("DOMContentLoaded", initSpanglesColorGuide);
